import { ThemeConfig } from 'antd';

// Ant Design Theme Configuration
export const antdTheme: ThemeConfig = {
  token: {
    // Primary Colors
    colorPrimary: '#1976d2', // Blue - matching your current theme
    colorSuccess: '#4caf50',
    colorWarning: '#ff9800',
    colorError: '#f44336',
    colorInfo: '#2196f3',
    
    // Font
    fontSize: 14,
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',
    
    // Border
    borderRadius: 8,
    
    // Layout
    colorBgLayout: '#f5f5f5',
    colorBgContainer: '#ffffff',
  },
  components: {
    Button: {
      borderRadius: 8,
      controlHeight: 36,
      fontWeight: 500,
    },
    Card: {
      borderRadiusLG: 12,
      boxShadowTertiary: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)',
    },
    Table: {
      borderRadius: 8,
      headerBg: '#fafafa',
    },
    Input: {
      borderRadius: 6,
      controlHeight: 36,
    },
    Select: {
      borderRadius: 6,
      controlHeight: 36,
    },
  },
};

